import React, { Fragment } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper
} from "@material-ui/core";

export default class ComponentToPrint extends React.Component {
  render() {
    const { factoryItemList, searchData, groupFactoryItems, itemRequestDetail } = this.props;
    return (
      <div>
        <style>
          {`
            .MuiTableCell-root {
              padding: 2px !important;
            }
            .MuiTableRow-root {
              height: 20px !important;
              min-height: 20px !important;
            }
            @page {
              size: A4 portrait;
            }
          `}
        </style>

        <h3><center><u>Route Wise Factory Item Details Report</u></center></h3>
          <h4><center><b>Group : {searchData.groupName}</b></center></h4>
          <h4><center><b>Factory : {searchData.factoryName}</b></center></h4>
          <h4><center><b>From Date : {searchData.startDate} To Date : {searchData.endDate}</b></center></h4>
          <h4><center><b>Route : {searchData.routeName == undefined ? 'All Route' : searchData.routeName}</b></center></h4>
        <br />

        <Box style={{ minWidth: 1050, padding: 3 }}>
          {factoryItemList.length > 0 &&
            groupFactoryItems(factoryItemList).map((routeGroup) => (
              <Fragment key={routeGroup.routeName}>
                <Typography variant="h5" style={{ fontWeight: "bold", color: "#333", marginBottom: 10 }}>
                  Route: {routeGroup.routeName}
                </Typography>

                {routeGroup.categories.map((categoryGroup) => {
                  const totalQuantity = categoryGroup.items.reduce((sum, item) => sum + item.approvedQuantity, 0);
                  const totalPrice = categoryGroup.items.reduce((sum, item) => sum + item.totalPrice, 0);

                  return (
                    <Fragment key={categoryGroup.categoryName}>
                      <Typography variant="h6" style={{ marginBottom: 10 }}>
                        Category: {categoryGroup.categoryName}
                      </Typography>
                      <TableContainer component={Paper} style={{ marginBottom: 20 }}>
                        <Table style={{ tableLayout: "fixed", width: "100%" }}>
                          <TableHead>
                            <TableRow>
                              <TableCell style={{ textAlign: "left", fontWeight: 'bold' }}>Date</TableCell>
                              <TableCell style={{ textAlign: "left", fontWeight: 'bold' }}>Reg No.</TableCell>
                              <TableCell style={{ textAlign: "left", fontWeight: 'bold' }}>Supplier Name</TableCell>
                              <TableCell style={{ textAlign: "center", fontWeight: 'bold' }}>Item</TableCell>
                              <TableCell style={{ textAlign: "left", fontWeight: 'bold' }}>No. of Installments</TableCell>
                              <TableCell style={{ textAlign: "left", fontWeight: 'bold' }}>Payment Effective Month</TableCell>
                              <TableCell style={{ textAlign: "right", fontWeight: 'bold' }}>Unit Price</TableCell>
                              <TableCell style={{ textAlign: "right", fontWeight: 'bold' }}>Quantity</TableCell>
                              <TableCell style={{ textAlign: "right", fontWeight: 'bold' }}>Total Price (Rs)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {categoryGroup.items.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell style={{ textAlign: "left" }}>{item.date.split("T")[0]}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.registrationNumber}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.name}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.itemName}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.noOfInstallments}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.paymentEffectedMonth}</TableCell>
                                <TableCell style={{ textAlign: "right" }}>
                                  {Number(item.totalPrice/item.approvedQuantity).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                                <TableCell style={{ textAlign: "right" }}>{item.approvedQuantity}</TableCell>
                                <TableCell style={{ textAlign: "right" }}>
                                  {Number(item.totalPrice).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                              </TableRow>
                            ))}

                            <TableRow>
                              <TableCell style={{ fontWeight: "bold", textAlign: "left" }}>Total</TableCell>
                              <TableCell colSpan={6}></TableCell>
                              <TableCell style={{ fontWeight: "bold", textAlign: "right" }}>{totalQuantity}</TableCell>
                              <TableCell style={{ fontWeight: "bold", textAlign: "right" }}>{totalPrice.toFixed(2)}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Fragment>
                  );
                })}
              </Fragment>
            ))}
        </Box>
      </div>
    );
  }
}
